module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "size": 'confirm_size'
    }
  }, [_c('div', {
    staticClass: "h-full flex-grow"
  }, [_c('div', {
    staticClass: "flex flex-col text-center bg-emerald-50 rounded-t-lg py-12"
  }, [_c('span', [_c('i', {
    staticClass: "text-6xl fa fa-solid fa-check-circle text-emerald-600"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-8 py-6 px-5"
  }, [_c('div', {
    staticClass: "text-center flex flex-col space-y-4"
  }, [_c('span', {
    staticClass: "text-lg text-gray-700"
  }, [_vm._v("You've successfully created a Course!")]), _vm._v(" "), _c('div', {
    staticClass: "text-gray-700 font-poppins font-light"
  }, [_vm._v(" \n          Go to "), _c('span', {
    staticClass: "text-pinky hover:underline cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.handleGoToSettings()
      }
    }
  }, [_vm._v("Course Settings")]), _vm._v(" to set up a new LMS integration.\n        ")])]), _vm._v(" "), _c('button', {
    staticClass: "bg-emerald-500 hover:bg-emerald-600 rounded-md text-white px-2.5 py-2",
    on: {
      "click": function($event) {
        return _vm.handleGoToCoursePage()
      }
    }
  }, [_vm._v("Okay!")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-79cbf20c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/courses/components/courseCreatedModal.vue
// module id = 2441
// module chunks = 61